import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

export function useConsumption(serverId: string, since: Date, until: Date) {
  const api = useApiClient();

  return useQuery({
    queryKey: ['consumption', serverId, since.toISOString(), until.toISOString()],
    queryFn: () => api.consumption.byServer(serverId, since.toISOString(), until.toISOString()),
    enabled: !!serverId,
  });
}
